import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

export type QueryDeleteChoice = 'remove' | 'delete';

export interface QueryDeleteData {
  query: {
    name: string;
    groups?: string[];
    referenced_by?: { ylrn?: string; name?: string }[];
  };
  collectionId: string;
  collections: { uid: string; name: string }[];
}

const ARTIFACT_LABELS: Record<string, string> = {
  newsletter: 'newsletter',
  search_query: 'query',
  portfolio: 'portfolio',
};

/** Names the artifacts in `referenced_by` (ylrn:artifact:<type>:<uid>), once each. */
export function describeReferences(
  refs: { ylrn?: string; name?: string }[],
): { kind: string; name: string }[] {
  const seen = new Set<string>();
  return refs
    .filter((ref) => {
      const key = ref.ylrn ?? ref.name;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    })
    .map((ref) => {
      const type = ref.ylrn?.split(':')[2] ?? '';
      return {
        kind: ARTIFACT_LABELS[type] ?? type.replace(/_/g, ' '),
        name: ref.name ?? '',
      };
    });
}

/**
 * Confirms a query delete from a collection row. A query shared with other
 * collections can be removed from this one only; `referenced_by` lists every
 * artifact (newsletter, query, ...) that uses it, and those lose it too.
 */
@Component({
  selector: 'app-query-delete',
  templateUrl: './query-delete.component.html',
  styleUrls: ['./query-delete.component.scss'],
})
export class QueryDeleteComponent {
  readonly otherCollections: string[];
  readonly usedBy: { kind: string; name: string }[];

  constructor(@Inject(MAT_DIALOG_DATA) public data: QueryDeleteData) {
    const names = new Map(data.collections.map((c) => [c.uid, c.name]));
    this.otherCollections = (data.query.groups ?? [])
      .filter((uid) => uid !== data.collectionId && names.has(uid))
      .map((uid) => names.get(uid));
    this.usedBy = describeReferences(data.query.referenced_by ?? []);
  }
}
